import apiClient from './apiClient';
import { AppUser, BrokerConnection, BrokerConnectionSave } from '../types/user';

export interface TermsDocument {
  id: number;
  version: string;
  title: string;
  body: string;
  updated_at: string;
}

export interface TermsStatus {
  accepted: boolean;
  terms_id: number | null;
  version?: string;
  title?: string;
}

export const userService = {
  getMe: () =>
    apiClient.get<AppUser>('/api/users/me').then((r) => r.data),

  getBrokerConnections: () =>
    apiClient.get<BrokerConnection[]>('/api/users/me/broker').then((r) => r.data),

  saveBrokerConnection: (payload: BrokerConnectionSave) =>
    apiClient.post<BrokerConnection>('/api/users/me/broker', payload).then((r) => r.data),

  getActiveTerms: () =>
    apiClient.get<TermsDocument | null>('/api/users/terms/active').then((r) => r.data),

  getTermsStatus: () =>
    apiClient.get<TermsStatus>('/api/users/terms/status').then((r) => r.data),

  acceptTerms: () =>
    apiClient.post('/api/users/terms/accept').then((r) => r.data),

  addTicker: (ticker: string) =>
    apiClient.post<{ ticker: string; name: string | null; message: string }>('/api/users/tickers', { ticker }).then((r) => r.data),

  getNotifications: () =>
    apiClient.get<{
      unread_count: number;
      items: Array<{
        id: number; type: string; ticker: string; title: string;
        message: string; link: string | null; read: boolean; created_at: string;
      }>;
    }>('/api/users/notifications').then((r) => r.data),

  markNotificationsRead: () =>
    apiClient.post('/api/users/notifications/read').then((r) => r.data),

  listAllNotifications: (params?: { page?: number; page_size?: number; type?: string; ticker?: string }) =>
    apiClient.get('/api/users/notifications/all', { params }).then((r) => r.data),

  deleteNotifications: (params?: { type?: string; ticker?: string }) =>
    apiClient.delete('/api/users/notifications', { params }).then((r) => r.data),

  getPreferences: () =>
    apiClient.get<Record<string, unknown>>('/api/users/preferences').then((r) => r.data),

  savePreferences: (prefs: Record<string, unknown>) =>
    apiClient.put<Record<string, unknown>>('/api/users/preferences', prefs).then((r) => r.data),

  listTrades: (params?: { status?: string; ticker?: string }) =>
    apiClient.get('/api/users/trades', { params }).then((r) => r.data),

  createTrade: (payload: {
    ticker: string; strategy_name: string; legs: Array<{ side: string; option_type: string; strike: number; expiry?: string }>;
    contracts: number; entry_price: number; entry_date: string; notes?: string; source?: string;
  }) => apiClient.post('/api/users/trades', payload).then((r) => r.data),

  closeTrade: (tradeId: number, payload: {
    close_reason: string; close_date: string; close_price?: number; contracts?: number;
  }) => apiClient.post(`/api/users/trades/${tradeId}/close`, payload).then((r) => r.data),

  deleteTrade: (tradeId: number) =>
    apiClient.delete(`/api/users/trades/${tradeId}`).then((r) => r.data),
};
